import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Link.styles';

const Link = ({ className, children, to, ...rest }) => {

  const { nohref = false } = rest;

  const customProps = {
    ...!nohref && {href: to}, // add href if nohref=false
    ...rest
  }

  return (
    <S.Link className={className} {...customProps}>
      {children}
    </S.Link>
  );
};

Link.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired
};

Link.defaultProps = {
  className: null
};

export default Link;
